import Vue from 'vue'

import { installComponents } from '@/composables/install'

import * as core from '@/components/core'

const config = {
  package: require('../../package.json'),
  verbose: process.env.VUE_APP_ENV === 'dev',
}

installComponents(core, Vue, config)
